<template>
  <div class="file-preview video-file-preview">
    <video :src="src" controls style="max-width:100%;"></video>
  </div>
</template>

<script>
export default {
  name: 'VideoPreview',
  props: {
    src: String
  }
}
</script>